export enum ProcessStatus {
    HIDDEN, IN_PROGRESS
}
